import React from 'react';
import CtaBtn from './CtaBtn';
import LinkBtn from './LinkBtn';

const BtnContainer = (props) => (
    <div className="CtaContainer">
        <p className="subTitleFont">{props.content}</p>
        <props.btnType click={props.click} classes="subTitleFont" name="Let's Talk"/>
    </div>
)

export default BtnContainer;


// WEBPACK FOOTER //
// ./src/components/BtnContainer.js